<div class="iris-profile-info">
  <div class="nav-item"
       [class.show]="menuDropdownTrigger.menuOpen"
       data-test="header-profile-menu-button">
    <button class="nav-link"
            #menuDropdownTrigger="matMenuTrigger"
            [matMenuTriggerFor]="profileMenu"
            data-test="header-profile-info-button">
      <sk-iris-user class="user"
                    [userId]="me.id"
                    [avatarSize]="'sm'"
                    [showOnlyAvatar]="true"
                    [isCurrentUser]="true"
                    [noHint]="true"></sk-iris-user>
    </button>

    <mat-menu #profileMenu="matMenu"
              class="iris-dropdown-menu with-icon pt-2 pb-2"
              data-test="header-profile-menu">
      <ul class="list-group">
        <li data-test="header-profile-menu-main-link">
          <a class="dropdown-item" [routerLink]="[baseUrl(), 'profile']" id="profile" data-test="header-profile-info-profile-link">
            {{'label.MyProfile' | translate}}
          </a>
        </li>
        @if (me.isAdmin || me.isInternal) {
          <li data-test="header-profile-menu-styleguide-link">
            <a class="dropdown-item" target="_blank" [routerLink]="[baseUrl(), 'styleguide']" data-test="header-profile-info-link">
              {{'label.Styleguide' | translate}}
            </a>
          </li>
        }
        <li data-test="header-profile-menu-logoff-link">
          <a class="dropdown-item" (click)="logoff()" href="javascript:void(0)" id="logout" data-test="header-profile-info-logout-link">
            {{'label.Logout' | translate}}
          </a>
        </li>
      </ul>
    </mat-menu>
  </div>
</div>
